import { Component, Input } from '@angular/core';
import { OmniChatFacade } from '@cigna/omni/chat-state';
import { OmniConversationsFacade } from '@cigna/omni/conversations-state';

@Component({
  selector: 'cigna-omni-splash-close-screen',
  templateUrl: './chat-splash-close-screen.component.html',
  styleUrls: ['./chat-splash-close-screen.component.scss'],
})
export class OmniMessagingSplashCloseScreenComponent {
  @Input() public screenText: string;
  @Input() public conversationId: string;

  constructor(
    private omniChatFacade: OmniChatFacade,
    private cnvFacade: OmniConversationsFacade,
  ) {}

  public endChat() {
    this.omniChatFacade.closeDialog();
    this.cnvFacade.endConversation(this.conversationId);
  }

  public keepChat() {
    this.cnvFacade.setCloseSplashScreen(false);
  }
}
